const payment = {
	"detail-view": {
		title: "Payment {{invoice_number}}",
		information: "Information",
		invoice: "Invoice",
		students: "Professionals",
		"payment-failed": {
			title: "Payment failed",
			description:
				"Unfortunately, the payment has failed. You can still complete the payment using the button below.",
			button: "Try payment again",
		},
	},
	"index-view": {
		title: "My payments",
		"title-refresh": "Earnings of {{year}}",
		status: {
			reserved: "Reserved",
			coming: "On the way",
			paid: "Paid out",
		},
		cards: {
			open: "Outstanding payments",
			"open-worth": "Outstanding value",
			"open-invoices": "Open invoices",
		},
		tabs: {
			all: "All",
			open: "Open payments",
			credit: "Credit",
			reserved: "Reserved",
		},
	},
	"refresh-view": {
		title: "",
		error: {
			title: "Something went wrong",
			description:
				"If this problem persists, please contact support@{{tenant.slug}}.nl",
		},
		"invoice-created": {
			title: "The invoice has been created",
			"iframe-title": "Invoice",
		},
		failed: {
			title: "Unfortunately",
			"description-pending": "This payment is currently being processed",
			"description-disabled":
				"No new payment link can be created for this payment. The payment is already complete.",
			button: "Back to payments",
		},
		"account-disabled":
			"You can use your account again after the subscription has been paid",
	},
	"billing-upcoming-view": {
		title: "My subscription",
		back: "Back to subscriptions",
		"invoice-current": {
			title: "Invoice this month",
		},
	},
	"billing-view": {
		title: "My subscription",
		"payment-history": {
			title: "Payments",
		},
	},
	"change-mandate-view": {
		title: "Choose bank link",
		back: "Back to edit",
		header: {
			title: "Bank link",
			description:
				"This link is used for collecting the subscription fees, and if necessary, also for paying out the professional.",
		},
		form: {
			title: "Bank link:",
		},
		error: {
			title: "Something went wrong",
			description:
				"If this problem persists, please contact support@{{tenant.slug}}.nl",
		},
	},
	"change-plan-view": {
		title: "Change Subscription",
		back: "Back to Subscription",
		pause: "Pause Subscription",
		"subscription-head": {
			title: "Subscription",
			subtitle: "Choose a subscription that fits your organization.",
		},
		"mandate-head": {
			title: "Payment Method",
			subtitle:
				"This will be used for paying the subscription but also for the professional's payment.",
		},
	},
	"pause-plan-view": {
		title: "Pause Subscription",
		back: "Back to Change Subscription",
		confirm: {
			title: "Are you sure",
			description:
				"Are you sure you want to pause your subscription at {{tenant.name}}? The tasks that have already been placed will be immediately charged",
		},
		error: {
			title: "Something went wrong",
			description: "Please try again later",
		},
		"not-cancelable": {
			title: "Oops!",
			description:
				"You can't pause this subscription yourself. Please contact <1>support@{{tenant.slug}}.nl</1>",
		},
		form: {
			title: "What a shame...",
			description:
				"When you click the pause button we will stop the subscription. We always like to learn, would you like to indicate below why our cooperation no longer works?",
			placeholder: "I want to cancel my subscription because...",
			disclaimer:
				"When you pause, you can still use {{tenant.name}} until: {{date}}. The outstanding placement fees will then be charged",
			"current-usage":
				"This amount will be charged at the end of your subscription <1>View current usage</1>",
			"old-prices":
				"Note! You are still using the old prices, if you cancel you can no longer use this later.",
			cancel: "Cancel",
			pause: "Pause",
		},
		"already-paused": {
			title: "Your subscription has been paused",
			description: "Thanks for giving us feedback",
		},
	},
	"resume-plan-view": {
		title: "Resume Subscription",
		back: "Back to Change Subscription",
		error: {
			title: "Something went wrong",
			description: "Please try again later",
		},
		card: {
			title: "Resume Subscription",
			description:
				"When you click the resume button, the subscription will be resumed. The next charge will then be on {{date}}",
			cancel: "Cancel",
			resume: "Resume",
		},
	},
};

export default payment;
